import React, { useEffect, useState } from "react";
import { fireDB } from "../../firebase/FirebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";

const HomeBlogs = () => {
    const [blogs, setBlogs] = useState([]);

    const getBlogs = async () => {
        const snap = await getDocs(collection(fireDB, "blogs"));

        const blogList = snap.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .slice(0, 4);

        setBlogs(blogList);
    };

    useEffect(() => {
        getBlogs();
    }, []);

    return (
        <Container className="my-5">
            <h2 className="text-center mb-4 fw-bold">📝 Latest Travel Blogs</h2>

            <Row>
                {blogs.length > 0 ? (
                    blogs.map((blog) => (
                        <Col md={3} sm={6} xs={6} className="mb-4" key={blog.id}>
                            <Link
                                to={`/blog/${blog.id}`}
                                className="text-decoration-none text-dark"
                            >
                                <Card className="shadow-sm rounded-4 border-0 blog-card">
                                    <Card.Img
                                        variant="top"
                                        src={blog.thumbnail}
                                        className="rounded-top-4"
                                        style={{
                                            height: "210px",
                                            objectFit: "cover",
                                        }}
                                    />

                                    <Card.Body className="d-flex flex-column">

                                        <Card.Title className="fw-bold blog-title">
                                            {blog.title?.substring(0, 50)}...
                                        </Card.Title>

                                        <Card.Text className="text-muted blog-desc">
                                            {blog.shortDesc}
                                        </Card.Text>

                                        <div className="mt-auto">
                                            <small className="text-secondary">
                                                📅{" "}
                                                {blog.date
                                                    ? blog.date.toDate().toLocaleDateString()
                                                    : "No Date"}
                                            </small>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    ))
                ) : (
                    <p className="text-center mt-4">No blogs available.</p>
                )}
            </Row>

            <div className="text-center mt-3">
                <Link to="/blogs" className="btn btn-primary px-4 rounded-pill">
                    View More Blogs
                </Link>
            </div>
        </Container>
    );
};

export default HomeBlogs;
